import React, { FC } from "react";
import './styles.css';

export const Notification:FC<any> = (props:any) => {
    return(
        <span id="snackbar">{props.msg}</span>
    );
};